import React, { useState, type MutableRefObject } from 'react';
import Checkbox from '~/components/molecule/Checkbox';
import JustificationContainer from '~/components/atom/JustificationContainer';
import DropdownListContainer from '~/components/molecule/Dropdown/components/DropdownListContainer';
import {
  type OnChangeFunction,
  type Option,
} from '~/components/molecule/Dropdown';

type Props = {
  /** The table column object containing header properties and metadata. Used to apply header-specific props */
  column: any;
  /** Adds minus icon to the checkbox when there are selected items */
  minus: boolean;
  /** The value of the checkbox */
  value: boolean;
  /** Whether there are no rows in the table. When true, the checkbox is hidden to prevent interaction with empty tables */
  noRows: boolean;
  options: Array<Option>;
  onOptionChange: OnChangeFunction;
  onChange?: () => void;
};

const CheckboxHeaderCell = React.forwardRef<HTMLDivElement, Props>(
  (
    { column, onChange, minus, value, noRows, options, onOptionChange },
    headerCheckboxRef,
  ) => {
    const [showSelectOptions, setShowSelectOptions] = useState<boolean>(false);

    return (
      <div {...column.getHeaderProps()}>
        <JustificationContainer
          align="center"
          data-testid={column.dataTestId}
          height="100%"
          ref={headerCheckboxRef}
        >
          {!noRows && (
            <Checkbox
              name="selectAllCheckbox"
              value={value}
              minus={minus}
              isFocused={showSelectOptions}
              onChange={() => {
                onChange ? onChange() : setShowSelectOptions(true);
              }}
              large
            />
          )}
        </JustificationContainer>
        <DropdownListContainer
          dropdownListOpen={showSelectOptions}
          onClickOutside={() => setShowSelectOptions(false)}
          onClose={() => setShowSelectOptions(false)}
          options={options}
          onChange={option => {
            onOptionChange(option);
            setShowSelectOptions(false);
          }}
          openerRef={headerCheckboxRef as MutableRefObject<HTMLElement | null>}
        />
      </div>
    );
  },
);

export default CheckboxHeaderCell;
